import HeaderHealthSubItems from '@Components/Home/HeaderHealthSubItems';
import { useHomeLinks } from '@Components/Layout/hooks/useHomeLinks';
import { MainNav, NavItem } from '@tameeni/home';
import { Products } from '@tameeni/shared-logic';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomMainNav = () => {
  const {
    i18n: { language: locale },
    t,
  } = useTranslation(['products']);
  const {
    PRODUCTS_TO_SHOW,
    ICONS,
    getActiveProductMega,
    HOME_LINKS,
    GREY_ICONS,
    NEW_PRODUCTS,
    PRODUCTS_FLAT,
  } = useHomeLinks();
  return (
    <div className='max-w-[1280px] mx-auto z-50 pt-1'>
      <MainNav locale={locale}>
        <React.Fragment key='.0'>
          {PRODUCTS_TO_SHOW.map((product) => (
            <NavItem
              key={product}
              icon={
                (getActiveProductMega() === product ? ICONS : GREY_ICONS)[
                  product as keyof typeof ICONS
                ]
              }
              isActive={getActiveProductMega() === product}
              label={
                product === Products.HEALTH_SME
                  ? t('products:HEALTH_INSURANCE')
                  : t(
                      `products:${Object.keys(Products).find((key) => {
                        return Products[key as keyof typeof Products] === product;
                      })}`,
                    )
              }
              link={HOME_LINKS[product]}
              isNew={NEW_PRODUCTS.includes(product)}
              newBadge={NEW_PRODUCTS.includes(product) ? 'New' : undefined}
              isMegaMenu={product === Products.HEALTH_SME}
              megaMenuContent={
                product === Products.HEALTH_SME ? (
                  <HeaderHealthSubItems
                    HOME_LINKS={HOME_LINKS}
                    className='mx-auto flex flex-col md:flex-row gap-6 lg:gap-8 w-full max-w-7xl p-6 z-[12]'
                    PRODUCTS_FLAT={PRODUCTS_FLAT}
                  />
                ) : undefined
              }
            />
          ))}
        </React.Fragment>
      </MainNav>
    </div>
  );
};

export default CustomMainNav;
